export const UYGUNLUK = {
  bireysel: { label: "Bireysel Talebe Uygun", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  kurum: { label: "Yalnızca Firma/Kurum", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  inceleme: { label: "İnceleme Gerekli", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const QUOTE_STATUS = {
  yeni: { label: "Yeni Talep", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  fiyatlandiriliyor: { label: "Fiyatlandırılıyor", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  gonderildi: { label: "Teklif Gönderildi", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export function tl(v) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(v);
}

export function pkgLabel(it) {
  const parts = [];
  if (it.ambalaj) parts.push(it.ambalaj);
  return parts.join(" ");
}
